import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4f24592"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-hunt-begins-band" }
const _hoisted_2 = { class: "nge-hunt-begins-eyebrow" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-hunt-begins-title" }, "The Hunt begins!", -1 /* HOISTED */))
const _hoisted_4 = { class: "nge-hunt-begins-name" }
const _hoisted_5 = { class: "nge-hunt-begins-what" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return ($setup.showing)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "nge-hunt-begins",
        role: "status",
        onClick: $setup.close
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gems, (g, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: _normalizeClass(["nge-hunt-begins-gem", { 'nge-hunt-begins-gem--blue': g.blue }]),
              style: _normalizeStyle({ left: g.x + '%', animationDelay: g.delay + 's', animationDuration: g.dur + 's', width: g.size + 'px', height: g.size + 'px' })
            }, null, 6 /* CLASS, STYLE */))
          }), 128 /* KEYED_FRAGMENT */)),
          _createElementVNode("div", _hoisted_2, _toDisplayString($setup.showing.admins_only ? "The admins' test" : 'Pyr'), 1 /* TEXT */),
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, _toDisplayString($setup.showing.title), 1 /* TEXT */),
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.what) + " Happy Hunting!", 1 /* TEXT */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}